<!-- =========================================================================================
    File Name: ResetPassword.vue
    Description: Reset Password Page
    ----------------------------------------------------------------------------------------
========================================================================================== -->

<template>
  <div class="h-screen flex w-full bg-img">
    <div class="vx-col sm:w-3/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row">
            <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
              <img src="@/assets/images/pages/reset-password.png" alt="login" class="mx-auto">
            </div>
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center  d-theme-dark-bg">
              <div class="p-8">
                <div class="vx-card__title mb-8">
                  <h4 class="mb-4">Reimposta Password</h4>
                  <p>Sono passati 6 Mesi dall'ultimo cambio di password, per motivi di sicurezza è necessario impostarne una nuova.</p>
                  <br>
                  <p>Inserire la nuova password.</p>
                </div>
                <p style="color:red">{{this.error}}</p>
                <p id="pw_err" class="scadenza_red text-center" style="color:white;"></p>
                <form v-on:submit.prevent="" data-vv-scope="utente" autocomplete="off">
                  <!-- <vs-input type="email" label-placeholder="Email" v-model="value1" class="w-full mb-6" /> -->

                  <vs-input type="password" name="password" label-placeholder="Password" v-model="password" class="w-full mb-6" v-validate="'required|min:8|max:64|is_password'" ref="password" />
                  <span class="text-danger text-sm" v-show="errors.has('utente.password')">{{ errors.first('utente.password') }}</span>

                  <vs-input type="password" name="repassword" label-placeholder="Conferma Password" v-model="repassword" class="w-full mb-8" v-validate="'required|confirmed:password'" />
                  <span class="text-danger text-sm" v-show="errors.has('utente.repassword')">{{ errors.first('utente.repassword') }}</span>
                </form>
                <div class="flex flex-wrap justify-between flex-col-reverse sm:flex-row">
                  <!-- <vs-button type="border" to="/pages/login" class="w-full sm:w-auto mb-8 sm:mb-auto mt-3 sm:mt-auto">Go Back To Login</vs-button> -->
                  <vs-button :disabled="this.checkDis()" @click="reset_pw" class="w-full sm:w-auto">Reimposta</vs-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

// For custom error message
import { Validator } from 'vee-validate';

const dict = {
  utente: {
    // email: {
    //   required: 'Email è un campo obbligatorio',
    //   email: 'Inserire un indirizzo email valido',
    // },
    password: {
      required: 'Inserire una password',
      max: 'Inserire massimo 64 caratteri',
      min: 'Inserire almeno 8 caratteri',
      is_password: 'Almeno un simbolo, una maiuscola e un numero'
    },
    repassword: {
      required: 'Ripetere password'
    },
  }
};

// register custom messages
Validator.localize('it', dict);
function isPW(pw)
{
	if( pw == '' ) { return true }
  var upper = pw.match(/[A-Z]/g)
  var num = pw.match(/[0-9]/g)
  var symb = pw.match(/[!@#$€£%^&*(),.?"=\-'_:{}[\]|<>]/g)
	if( upper && num && symb ) {
		return true
  }
	return false
}

Validator.extend('is_password', isPW);

export default {
  data() {
    return {
      error: '',
      // value1: '',
      password: '',
      repassword: '',
    }
  },
  props: {
    id: null
  },

  methods: {
    reset_pw() {
      if (this.password != this.repassword) {
        this.error = 'Le due password non corrispondono'
        return
      } else {
        let obj = {
          id: this.id,
          password: this.password,
          pw_reset: false,
        }
        axios.post(process.env.VUE_APP_BACKEND_API+'/utente/check_pw', obj, {
            headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
            withCredentials: true,
        })
        .then(res => {
          document.getElementById("pw_err").innerText = ''
          if (res.data == 500) {
            document.getElementById("pw_err").innerText = 'La password non può essere uguale ad una precedente'
          } else {
            axios.post(process.env.VUE_APP_BACKEND_API+'/utente/modifica', obj, {
              headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
              withCredentials: true,
            })
            .then(() => {
              // console.log("Email sent");
              this.$router.push('/pages/login')
            })
            .catch(() => this.error = 'Qualcosa è andato storto, riprovare o contattare amminstratore di sistema.')
          }
        })
      }
    },
    checkDis() {
      return (document.getElementById("pw_err") && document.getElementById("pw_err").innerText.length) ? true : false
    },
  }
}
</script>
